import { render, staticRenderFns } from "./ModalFormBusinessUnitPerson.vue?vue&type=template&id=460869ca"
import script from "./ModalFormBusinessUnitPerson.vue?vue&type=script&lang=js"
export * from "./ModalFormBusinessUnitPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('460869ca')) {
      api.createRecord('460869ca', component.options)
    } else {
      api.reload('460869ca', component.options)
    }
    module.hot.accept("./ModalFormBusinessUnitPerson.vue?vue&type=template&id=460869ca", function () {
      api.rerender('460869ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalFormBusinessUnitPerson.vue"
export default component.exports